import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "@/i18n";
import { ShoppingCart, Utensils, BookOpen, BarChart3, Settings, ChefHat, Calendar } from "lucide-react";

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isActive = (path) => location.pathname === path;

  const NavItem = ({ path, icon: Icon, label, testId }) => (
    <button 
      onClick={() => navigate(path)} 
      className={`flex-1 flex flex-col items-center gap-1 py-3 ${isActive(path) ? 'text-black dark:text-white' : 'text-gray-400'}`}
      data-testid={testId}
    >
      <Icon size={24} strokeWidth={isActive(path) ? 2 : 1.5} />
      <span style={{fontSize: '0.75rem'}} className="font-semibold">{label}</span>
    </button>
  );

  return (
    <nav className="bottom-nav">
      <NavItem path="/" icon={ShoppingCart} label={t('nav.lists')} testId="nav-lists" />
      <NavItem path="/recipes" icon={ChefHat} label={t('nav.recipes')} testId="nav-recipes" />
      <NavItem path="/meal-planning" icon={Calendar} label={t("nav.meals")} testId="nav-meals" />
      <NavItem path="/analytics" icon={BarChart3} label={t('nav.stats')} testId="nav-stats" />
      <NavItem path="/settings" icon={Settings} label={t('nav.settings')} testId="nav-settings" />
    </nav>
  );
};
